import styled from 'styled-components/macro'
import { COLORS } from '../../assets/styles/colors'

export const FisrtLevel = styled.h1`
  color: ${COLORS.NEUTRAL_800};
  font-family: OpenSansBold, sans-serif, arial;
  font-size: 1.75rem;
  line-height: inherit;
  margin: 0;
  text-align: center;
`
export const SecondLevel = styled.h2`
  color: ${COLORS.NEUTRAL_800};
  font-family: OpenSansBold, sans-serif, arial;
  font-size: 1.4375rem;
  line-height: inherit;
  margin: 0.625rem 0 1.875rem 0;
`

export const ThirdLevel = styled.h3`
  color: ${COLORS.NEUTRAL_600};
  font-family: OpenSansBold, sans-serif, arial;
  font-size: 1.1875rem;
  line-height: inherit;
  margin: 0 0 0.9375rem 0;
`
